<template>
  <div class="d-flex align-center white--text font-weight-medium primary px-4 py-3" v-on="$listeners">
    <v-icon v-if="icon" color="#fff" class="mr-3"> {{ icon }} </v-icon>
    <p class="flex-grow-1 font-size-14">{{ name }}</p>
    <v-icon v-if="!hideExpanding" color="#fff"> {{ expanded ? 'mdi-chevron-up' : 'mdi-chevron-down' }} </v-icon>
  </div>
</template>

<script>
export default {
  name: 'SidebarBodyHeader',
  props: {
    icon: {
      type: String,
      default: 'mdi-map-marker',
    },
    name: {
      type: String,
      default: '',
    },
    expanded: {
      type: Boolean,
      default: false,
    },
    hideExpanding: {
      type: Boolean,
      default: false,
    },
  },
};
</script>

<style lang="scss" scoped>
.v-icon::after {
  background-color: transparent;
}
</style>
